package com.hyperether.goodjob

import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.runtime.MutableState
import androidx.compose.runtime.mutableStateOf
import androidx.compose.ui.geometry.Size
import androidx.compose.ui.unit.Density
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.TextUnit
import androidx.compose.ui.unit.sp
import com.hyperether.goodjob.util.toScaleDp
import org.lighthousegames.logging.logging

val log = logging("Sizes")

fun dpToSizeInPx(maxWidth: Dp, maxHeight: Dp, density: Density): Size {
    val widthPx = with(density) { maxWidth.toPx() }
    val heightPx = with(density) { maxHeight.toPx() }
    return Size(widthPx, heightPx)
}

val containerSize: MutableState<Size> = mutableStateOf(Size.Zero)
val containerSizeDp: MutableState<Dp> = mutableStateOf(Dp(0f))
fun Sp(size: Float): TextUnit = when {
//    isWebMobileView() -> (size * 3).sp // TODO: check how it looks on Android device Web
    is4K() -> (size * 2).sp
    else -> size.sp
}

fun Dp(size: Float): Dp = when {
//    isWebMobileView() -> Dp(size * 3) // TODO: check how it looks on Android device Web
    is4K() -> Dp(size * 2)
    else -> Dp(size)
}

fun is4K(): Boolean {
//    log.d("SIZE RESOLUTION: ") { "IS 4K:  width=${containerSize.value.width}, height=${containerSize.value.height}" }
    return containerSize.value.width >= 3700f && containerSize.value.height >= 2090f
}

fun isWebMobileView(): Boolean {
    val isWebMobileView = getPlatformChecker().isMobileWebView()
//    log.d("isWebMobileView: ") { "isWebMobileView: $isWebMobileView, getPlatformChecker().isMobileWebView(): ${getPlatformChecker().isMobileWebView()}" }
    return isWebMobileView
}

@Composable
fun boxMargin(): Dp {
    return 16.toScaleDp()
}

@Composable
fun boxCornerShape(): RoundedCornerShape {
    return RoundedCornerShape(4.toScaleDp())
}

@Composable
fun addItemMargin(): Dp {
    return 40.toScaleDp()
}

@Composable
fun itemDetailsMenuMargin(): Dp {
    return 10.toScaleDp()
}

@Composable
fun itemDetailsMargin(): Dp {
    return 24.toScaleDp()
}

@Composable
fun webDetailsTitle(): Dp {
    return 90.toScaleDp()
}
